export const IMPORT_STUDY_MESSAGES = {
  UNSUPPORTED_FORMAT: 'Please upload DICOM (.dcm) or ZIP files only.',
  NO_DICOM_FOUND: 'No valid DICOM images were found in the selected file(s).',
  EMPTY_ZIP: 'No DICOM images were found in this ZIP file.',
  ZIP_READ_FAILED: 'We could not read this ZIP file. Please try another file.',
  FILE_TOO_LARGE: 'This file is too large. Please choose a smaller file.',
  PARSE_FAILED: 'We could not read these DICOM files. Please check the files and try again.',
  LOAD_FAILED: 'The study could not be loaded in the viewer. Please try again.',
  DUPLICATE_STUDY: 'This study has already been imported.',
  SUCCESS: 'Study imported successfully.',
} as const;
